export const ViewsMenuSettingsStyles = {
  containerButtons: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    marginBottom: "15px",
  },

  description: {
    fontStyle: "italic",
    fontSize: "0.6em",
  },
  formatLocale: {
    fontWeight: "normal",
    fontSize: "0.75em",
  },
  // Dialog Title
  dialogTitle: {
    fontWeight: 500,
  },

  // Content sections
  contentContainer: {
    paddingTop: 2,
  },

  fieldsContainer: {
    marginTop: 2,
  },

  // Switch section
  switchLabelContainer: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },

  switchText: {
    color: "#1976d2",
    fontStyle: "italic",
  },

  comingSoonBadge: {
    backgroundColor: "#e3f2fd",
    color: "#1976d2",
    padding: "2px 8px",
    borderRadius: "12px",
    fontSize: "0.75rem",
    fontWeight: "500",
  },

  switchFormControl: {
    opacity: 0.7,
    cursor: "help",
  },

  // Text fields
  nameField: {
    marginBottom: 2,
  },

  // Dialog actions
  dialogActions: {
    padding: 2,
    paddingTop: 0,
  },

  cancelButton: {
    textTransform: "none",
  },

  saveButton: {
    textTransform: "none",
    backgroundColor: "#1976d2",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  },

  // Loading overlay
  backdrop: {
    color: "#fff",
    zIndex: (theme: any) => theme.zIndex.modal + 1,
    position: "absolute",
    borderRadius: 1,
  },

  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  loadingText: {
    marginTop: 2,
  },

  // SavedViewsList styles
  noViewsText: {
    textAlign: "center",
    paddingY: 2,
  },

  viewsList: {
    padding: 0,
  },

  listItem: {
    paddingX: 0,
    paddingY: 2,
  },

  listItemEnabled: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
    opacity: 1,
  },

  listItemDisabled: {
    cursor: "default",
    "&:hover": {
      backgroundColor: "transparent",
    },
    opacity: 0.6,
  },

  deleteButton: {
    color: "#d32f2f",
  },

  viewTitle: {
    fontWeight: 500,
  },
  viewTitleDisabled: {
    fontWeight: 500,
    color: "#9e9e9e",
  },

  // ViewsMenu styles
  menuContainer: {
    width: 350,
    padding: 3,
    backgroundColor: "#fff",
    borderRadius: 1,
  },

  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 2,
  },

  closeButton: {
    color: "#1976d2",
    padding: 0,
  },

  closeButtonText: {
    marginLeft: 0.5,
    textTransform: "none",
  },

  menuTitle: {
    marginBottom: 1,
    fontWeight: 500,
  },

  menuDescription: {
    marginBottom: 2,
  },

  saveCurrentViewButton: {
    textTransform: "none",
    paddingY: 1.5,
    flex: 1,
    backgroundColor: "#1976d2",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  },

  resetViewButton: {
    textTransform: "none",
    paddingY: 1.5,
    flex: 1,
    color: "#d32f2f",
    borderColor: "#d32f2f",
    "&:hover": {
      borderColor: "#c62828",
      backgroundColor: "rgba(211, 47, 47, 0.04)",
    },
  },

  searchField: {
    marginBottom: 2,
  },

  // SuccessMessage styles
  snackbar: {
    "& .MuiSnackbarContent-root": {
      minWidth: "auto",
    },
  },

  successAlert: {
    width: "100%",
    backgroundColor: "#4caf50",
    color: "#fff",
    fontWeight: 500,
    boxShadow: "0 4px 12px rgba(76, 175, 80, 0.4)",
    "& .MuiAlert-icon": {
      color: "#fff",
    },
  },
} as const;
